import React from "react";
import styled from "styled-components";

import { Card, Text, Tag, colors } from "@trailhead/asurion-ui";
import { CardType } from "../../types";
import { CustomButton } from "../customButtons";
import { AppCTA } from "./AppCTA";
import { PossibleOS } from "../../utils";

const StyledCard = styled(Card)`
    padding: 0;
    max-width: 23.75rem;
    min-width: 15.5rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: transparent;
    position: relative;

    &:active {
        background-color: transparent;
    }
`;

const CardBody = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.5rem;
    flex-grow: 1;
`;

const Headings = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    align-items: flex-start;
    gap: 0.25rem;
`;

const Footer = styled.div`
    gap: 0.75rem;
    display: flex;
    flex-direction: column;
`;

const ImageContainer = styled.div`
    border-radius: 0.5rem 0.5rem 0 0;
    width: 100%;
    overflow: hidden;
    display: flex;
    height: 12.75rem;
    position: relative;
    justify-content: center;

    & > img {
        position: relative;
        z-index: -1;
        min-width: 100%;
        object-fit: cover;
        object-position: top center;
    }
`;

const StyledTag = styled(Tag)`
    position: absolute;
    z-index: 1;
    top: 1rem;
    right: 1rem;
`;

const Body = styled(Text)``;
const Buttons = styled.div``;

const ContentCard = (props: CardType): JSX.Element => {
    const {
        heading, subheading, body,
        image, primaryCTA, tag,
    } = props;

    return (
        <StyledCard
            type="call-to-action"
        >
            {!!tag && (
                <StyledTag
                    type="success"
                    text={tag}
                />
            )}
            <ImageContainer>
                <img src={image} />
            </ImageContainer>
            <CardBody>
                <Headings>
                    <Text
                        size={4}
                        weight="feather"
                        dangerouslySetInnerHTML={{ __html: heading }}
                    />
                    <Text
                        color={colors.neutralDeepest}
                        size={2}
                        weight="base"
                        dangerouslySetInnerHTML={{ __html: subheading }}
                    />
                </Headings>
                <Footer>
                    {body && (
                        <Body
                            size={3}
                            dangerouslySetInnerHTML={{ __html: body }}
                        />
                    )}
                    {primaryCTA && (
                        <Buttons>
                            <CustomButton {...primaryCTA} />
                        </Buttons>
                    )}
                </Footer>
            </CardBody>
        </StyledCard>
    );
};

export const CustomContentCard = (props: CardType): JSX.Element => {
    const { cardType } = props;

    // TODO: Apply validation for data passed to components here. Fail loudly.
    switch (cardType) {
        case "app-cta-banner--os-agnostic--gray-bg":
            return <AppCTA osOverride={PossibleOS.UNKNOWN} {...props} />
        default:
            return <ContentCard {...props} />
    }
};
